import {
  getChildrenFileList,
  removeFile,
  makeBackup,
} from '@/api/backupdbserv'

export default {
  state: {
    state_BackupDb_GetChildrenFileListResult: null,
    state_BackupDb_RemoveFileResult: null,
    state_BackupDb_MakeBackupResult: null,
  },
  mutations: {
    SET_BACKUPDB_GETCHILDRENFILELIST_RESULT: (state, rst) => {
      state.state_BackupDb_GetChildrenFileListResult = rst;
    },
    SET_BACKUPDB_REMOVEFILE_RESULT: (state, rst) => {
      state.state_BackupDb_RemoveFileResult = rst;
    },
    SET_BACKUPDB_MAKEBACKUP_RESULT: (state, rst) => {
      state.state_BackupDb_MakeBackupResult = rst;
    },
  },
  actions: {
    BackupDbServ_GetChildrenFileList({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getChildrenFileList(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_BACKUPDB_GETCHILDRENFILELIST_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_BACKUPDB_GETCHILDRENFILELIST_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    BackupDbServ_RemoveFile({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        removeFile(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_BACKUPDB_REMOVEFILE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_BACKUPDB_REMOVEFILE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    BackupDbServ_MakeBackup({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        makeBackup(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_BACKUPDB_MAKEBACKUP_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_BACKUPDB_MAKEBACKUP_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_BackupDb_GetChildrenFileListResult: state => {
      return state.state_BackupDb_GetChildrenFileListResult;
    },
    get_BackupDb_RemoveFileResult: state => {
      return state.state_BackupDb_RemoveFileResult;
    },
    get_BackupDb_MakeBackupResult: state => {
      return state.state_BackupDb_MakeBackupResult;
    },
  }
}